export default class ApiError extends Error {
  status: number;
  name: string;
  erpSystemName?: string;
  erpErrorDetails?: string;

  constructor(
    status: number,
    message: string,
    erpSystemName?: string,
    erpErrorDetails?: string,
  ) {
    super(message); // calling the parent class constructor
    this.status = status;
    this.name = 'ApiError';
    this.erpSystemName = erpSystemName;
    this.erpErrorDetails = erpErrorDetails;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
